export default {
  title: {
    en: 'Thank you',
  },
  text: {
    en: 'Your subscription plan has been successfully updated. Your next charge will be ${price}',
  },
  buttonTitle: {
    en: 'Got it',
  },
}
